import React from "react";
import CommonModal from "../../../../../Common/CommonModal";

import SFRTA_DailyMaterialUsageReport from "../../../../../Reports/SFRTA/DailyMaterialUsageReport";
import SFRTA_RecordofDisturbanceForRailAndTrackComponentsReport from "../../../../../Reports/SFRTA/RecordofDisturbanceForRailAndTrackComponentsReport";
import ONR_CwrRailLayingAndDistressingRecord from "../../../../../Reports/ONR/CwrRailLayingAndDistressingRecord";
import ONR_InServiceRailFailureReport from "../../../../../Reports/ONR/InServiceRailFailureReport";
import ONR_CwrMaintenanceRecordForm from "../../../../../Reports/ONR/CwrMaintenanceRecordForm";
import SFRTA_TrackDisturbanceReport from "../../../../../Reports/SFRTA/TrackDisturbanceReport";
import ONR_ChangeInCurveReport from "../../../../../Reports/ONR/ChangeInCurveReport";
import SCFE_RecordOfDisturbanceReport from "../../../../../Reports/SCFE/RecordOfDisturbanceReport";
import SCFE_JointBarFractureReport from "../../../../../Reports/SCFE/JointBarFractureReport";
import NonComplaintReport from "../../../../../Reports/ReVAMP/NonComplaintMaintanence/NonComplaintMaintanence";
import WorkGangReport from "../../../../../Reports/PATH/WorkGangReport";

const ReportMrModel = (props) => {
  return (
    <CommonModal headerText={""} setModalOpener={props.openReportModelMethod} modalStyle={{ maxWidth: "90vw" }} footerCancelText={"Close"}>
      {props.formId && <ReportModelBody inspec={props.selectedRowData} formId={props.formId} materialTypes={props.materialTypes} />}

      {props.summaryFormData &&
        props.summaryFormData.data.map((data) => {
          return <ReportModelBody inspec={data} formId={props.summaryFormData.id} materialTypes={props.materialTypes} />;
        })}
    </CommonModal>
  );
};

export default ReportMrModel;

const ReportModelBody = (props) => {
  function getSignature() {
    if (inspec && inspec.user && inspec.user.signature && inspec.user.signature.imgName) {
      return inspec.user.signature.imgName;
    }
  }
  const inspec = props.inspec;
  const reportOptions = {
    sfrta_m_dailyMaterialUsageForm: (
      <SFRTA_DailyMaterialUsageReport inspec={inspec} key={inspec._id} isMaintenance={true} materialTypes={props.materialTypes} />
    ),
    sfrta_m_weldForm: <SFRTA_RecordofDisturbanceForRailAndTrackComponentsReport inspec={inspec} key={inspec._id} isMaintenance={true} />,
    onr_m_cwrRailLayingAndDestressingForm: <ONR_CwrRailLayingAndDistressingRecord inspec={inspec} key={inspec._id} isMaintenance={true} />,
    onr_m_inServiceRailFailureAndMorbForm: (
      <ONR_InServiceRailFailureReport inspec={inspec} key={inspec._id} signatureImage={getSignature()} isMaintenance={true} />
    ),
    onr_m_cwrMaintenanceRecordForm: (
      <ONR_CwrMaintenanceRecordForm inspec={inspec} key={inspec._id} signatureImage={getSignature()} isMaintenance={true} />
    ),
    sfrta_m_trackDisturbanceForm: <SFRTA_TrackDisturbanceReport inspec={inspec} key={inspec._id} isMaintenance={true} />,
    onr_m_changeInCurveForm: <ONR_ChangeInCurveReport inspec={inspec} key={inspec._id} isMaintenance={true} />,
    scfe_m_CFRCRecordOfCWR: <SCFE_RecordOfDisturbanceReport inspec={inspec} key={inspec._id} isMaintenance={true} />,
    scfe_m_CWRJointBarFracture: <SCFE_JointBarFractureReport inspec={inspec} key={inspec._id} isMaintenance={true} />,

    maintenanceActivity_m: <NonComplaintReport inspec={inspec} key={inspec._id} isMaintenance={true} maintenanceType={"activity"} />,

    injectorChangeRecord_m: <NonComplaintReport inspec={inspec} key={inspec._id} isMaintenance={true} maintenanceType={"injector"} />,

    workGangAppForm_m: <WorkGangReport inspec={inspec} key={inspec._id} isMaintenance={true} />,
  };

  return inspec && reportOptions[props.formId] ? reportOptions[props.formId] : null;
};



// WEBPACK FOOTER //
// ./src/components/Maintenance/MaintenanceDetailPage/DetailViews/DetailViewModels/ReportModel.jsx/ReportMRModel.jsx